import { Icon as LegacyIcon } from '@ant-design/compatible'
import {
  ExclamationCircleOutlined,
  InfoCircleOutlined
} from '@ant-design/icons'
import mainStore from '@components/Main/store'
import { getObjValue, switchCase } from '@hlj/hlj-utils'
import { HeaderView } from '@merchant-backend/common-components'
import { Button, Col, Modal, Row } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory, Link } from 'react-router'
import store from './store'
import style from './style.module.less'

@observer
export default class extends Component {
  constructor(p) {
    super(p)
    const {
      location: {
        query: { errno }
      }
    } = this.props

    store.statusAuthorize = +errno

    if (+errno === 1 || +errno === 2 || +errno === 3) {
      store.failVisible = true
    }
  }

  componentDidMount() {
    store.judgeOvertime()
  }

  handleClose = () => {
    store.close('shareVisible')
    hashHistory.push('/localMerchant/home')
  }

  render() {
    const {
      shopInfo: { merchant_weapp }
    } = mainStore
    let type = getObjValue(merchant_weapp, 'type')
    let _status = getObjValue(merchant_weapp, 'status')
    let auth_status = getObjValue(merchant_weapp, 'auth_status')
    let link

    if (type == '1') {
      link = '/localMerchant/liteApp/manage'
    } else {
      if (_status == '2') {
        if (auth_status == '1') {
          link = '/localMerchant/liteApp/manage'
        } else {
          link = '/localMerchant/liteApp/authorize'
        }
      } else {
        if (auth_status == '0' || auth_status == '2') {
          link = '/localMerchant/liteApp/authorize'
        } else {
          link = '/localMerchant/liteApp/manage'
        }
      }
    }

    const header = [<Link to={link}>小程序</Link>, '小程序授权']
    const {
      visible,
      failVisible,
      vipVisible,
      statusAuthorize,
      shareVisible
    } = store
    return (
      <HeaderView header={header} title="小程序授权">
        <div className={style.authorize}>
          <div className={style.desc}>
            <p>
              将微信小程序授权给婚礼纪，系统会自动帮你生成店铺小程序，并提交到微信；你不需要做复杂操作，即可获得店铺的微信小程序
            </p>
            <p>
              如果你还没有注册微信小程序，点击下方按钮注册；注册成功后，在授权给婚礼纪即可
            </p>
          </div>
          <Row>
            <Col span={12} style={{ height: 231 }}>
              <div style={{ height: 165, margin: '0 0 50px 32px' }}>
                <img
                  src="http://qnm.hunliji.com/o_1bo9fm27a1josmbj1iuq1o5u1pod8.png"
                  style={{ height: '100%' }}
                />
              </div>
              <Link
                style={{ marginLeft: 60 }}
                className={style.btn}
                onClick={store.getAuth}
              >
                授权微信小程序
              </Link>
            </Col>
            <Col span={12}>
              <div style={{ height: 165, marginBottom: 50 }}>
                <img src="http://qnm.hunliji.com/o_1bo9fm27b12j115rvo9a6ii4id9.png" />
              </div>
              <Link
                style={{ marginLeft: 50 }}
                className={style.btn}
                href="https://mp.weixin.qq.com/wxopen/waregister?action=step1"
                target="_blank"
                rel="noopener noreferrer"
              >
                没有小程序账号？前往注册
              </Link>
            </Col>
          </Row>
          <div className={style.desc} style={{ marginTop: 36 }}>
            <p>
              在注册时，需要同时进行微信认证，微信平台将会收取300/次的费用。
              <span style={{ color: 'red' }}>
                *如果您有已经认证的微信服务号，那么可直接在微信后台快速开通小程序，不需要再次付费认证。
              </span>
            </p>
          </div>
          <div className={style.qa}>
            <h4>常见问题</h4>
            <p>
              1、为什么升级小程序，<a
                href="https://m.hunliji.com/p/wedding/Public/wap/m/business-school-detail/index.html?id=175"
                target="_blank"
                rel="noopener noreferrer"
              >
                点击查看
              </a>
            </p>
            <p>
              2、微信公众号如何绑定/关联小程序，<a
                href="https://mp.weixin.qq.com/debug/wxadoc/introduction/#小程序绑定微信开放平台帐号"
                target="_blank"
                rel="noopener noreferrer"
              >
                点击查看
              </a>
            </p>
            <p>3、如果有其他问题，请联系我们</p>
          </div>
        </div>
        <Modal
          visible={visible}
          title={
            <p style={{ fontSize: 16 }}>
              <InfoCircleOutlined
                style={{
                  color: '#448afc',
                  fontSize: 18,
                  marginRight: 10,
                  verticalAlign: 'bottom'
                }}
              />提示
            </p>
          }
          maskClosable={false}
          onCancel={store.cancel('visible')}
          width={400}
          footer={[
            <Button key="back" onClick={store.getAuth}>
              遇到问题，重试
            </Button>,
            <Button key="submit" type="primary" onClick={store.doneAuth}>
              已完成授权
            </Button>
          ]}
        >
          <p style={{ height: 50, fontSize: 14 }}>
            请在新窗口中完成微信小程序授权
          </p>
        </Modal>

        <Modal
          visible={failVisible}
          title={
            <p style={{ fontSize: 16 }}>
              <LegacyIcon
                type={'close-circle'}
                style={{
                  color: '#f04134',
                  fontSize: 18,
                  marginRight: 10,
                  verticalAlign: 'bottom'
                }}
              />授权失败
            </p>
          }
          maskClosable={false}
          onCancel={store.cancel('failVisible')}
          width={400}
          footer={[
            <Button key="back" onClick={store.cancel('failVisible')}>
              取消
            </Button>,
            <Button key="submit" type="primary" onClick={store.getAuth}>
              重新授权
            </Button>
          ]}
        >
          <p style={{ height: 50, fontSize: 14 }}>
            {switchCase(statusAuthorize + '', {
              '1':
                '权限不足，请重新授权。需要授予的权限：账号管理权限、开发管理与数据分析权限、客服消息管理权限。',
              '2': '授权过程出错，请重新授权！',
              '3':
                '信息填写出错，请检查小程序类目是否正常填写(需要与实际经营范围一致)，以及小程序昵称、头像、简介是否正常填写。 如仍有疑问，请联系婚礼纪客服。'
            })}
          </p>
        </Modal>

        <Modal
          visible={vipVisible}
          onCancel={store.cancel('vipVisible')}
          onOk={store.toVip}
          width={460}
          closable={false}
          okText="续费"
        >
          <div className={style.overtime}>
            <p>
              <ExclamationCircleOutlined
                style={{ fontSize: 16, color: 'orange', marginRight: 10 }}
              />
              小程序已到期，在微信中已无法正常使用
            </p>
            <p className={style.tips}>续费成功后，可以继续使用。</p>
          </div>
        </Modal>

        <Modal
          visible={shareVisible}
          onCancel={this.handleClose}
          onOk={store.toPro}
          width={460}
          closable={false}
          okText="续费"
        >
          <div className={style.overtime}>
            <p>
              <ExclamationCircleOutlined
                style={{ fontSize: 16, color: 'orange', marginRight: 10 }}
              />
              商家服务（付费）已到期，小程序在微信中已无法正常使用
            </p>
            <p className={style.tips}>续费成功后，可以继续使用。</p>
          </div>
        </Modal>
      </HeaderView>
    )
  }
}
